// extracted by mini-css-extract-plugin
module.exports = {"reportDivider":"ReportTableListQualified_reportDivider__3aHCb"};